"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
require("../layout.sass");
var navbar_1 = __importDefault(require("../navbar/navbar"));
var Layout = function (_a) {
    var children = _a.children, showFooter = _a.showFooter, FooterComponent = _a.FooterComponent, style = _a.style;
    var renderFooter = function () {
        return react_1.default.createElement(FooterComponent, null);
    };
    return (react_1.default.createElement("div", { className: "layout", style: __assign({}, style) },
        react_1.default.createElement(navbar_1.default, null),
        react_1.default.createElement("div", { className: "card" },
            react_1.default.createElement.apply(react_1.default, __spreadArray(["div", { className: "container" }], children, false)),
            showFooter && renderFooter())));
};
exports.default = Layout;
